import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faTachometerAlt,
  faTrophy,
  faFire,
  faBolt,
  faDesktop,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./OnlineInGameStats.module.css";

export const OnlineInGameStats = ({ onlineGame }) => {
  if (!onlineGame) return null;

  const gameStats = onlineGame.getGameStats();
  const gameSettings = onlineGame.gameSettings;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const formatTimeRemaining = (currentTime, timeLimit) => {
    const remaining = Math.max(0, timeLimit - currentTime);
    return formatTime(remaining);
  };

  const getGameModeIcon = (gameMode) => {
    switch (gameMode) {
      case "time_attack":
        return faClock;
      case "survival":
        return faFire;
      case "speed_battle":
        return faBolt;
      default:
        return faTrophy;
    }
  };

  const isTimeRunningOut =
    gameSettings.timeLimit && gameSettings.timeLimit - gameStats.gameTime <= 30;

  return (
    <div className={styles.statsContainer}>
      {/* Game Mode Indicator */}
      <div className={styles.gameModeIndicator}>
        <FontAwesomeIcon icon={getGameModeIcon(gameStats.gameMode)} />
        <span className={styles.gameModeName}>
          {gameStats.gameMode.replace("_", " ")}
        </span>
      </div>

      {/* Time Display */}
      {gameSettings.timeLimit ? (
        <div
          className={`${styles.timeDisplay} ${
            isTimeRunningOut ? styles.timeWarning : ""
          }`}
        >
          <FontAwesomeIcon icon={faClock} className={styles.timeIcon} />
          <div className={styles.timeInfo}>
            <span className={styles.timeValue}>
              {gameStats.isTimeUp
                ? "TIME UP!"
                : formatTimeRemaining(
                    gameStats.gameTime,
                    gameSettings.timeLimit
                  )}
            </span>
          </div>
        </div>
      ) : (
        <div className={styles.timeDisplay}>
          <FontAwesomeIcon icon={faClock} className={styles.timeIcon} />
          <div className={styles.timeInfo}>
            <span className={styles.timeValue}>
              {formatTime(gameStats.gameTime)}
            </span>
          </div>
        </div>
      )}

      {/* Speed Multiplier */}
      {gameStats.currentSpeedMultiplier > 1.0 && (
        <div className={styles.speedDisplay}>
          <FontAwesomeIcon
            icon={faTachometerAlt}
            className={styles.speedIcon}
          />
          <div className={styles.speedInfo}>
            <span className={styles.speedValue}>
              {gameStats.currentSpeedMultiplier.toFixed(1)}x
            </span>
          </div>
        </div>
      )}

      {/* FPS Counter */}
      <div className={styles.timeDisplay}>
        <FontAwesomeIcon icon={faDesktop} className={styles.timeIcon} />
        <div className={styles.timeInfo}>
          <span className={styles.timeValue}>
            {Math.min(onlineGame.fixedFrameRate?.currentFps || 60, 60)} fps
          </span>
        </div>
      </div>
    </div>
  );
};
